import React, { h } from "preact";
import { AppPage } from "../_common/components/app-page";
import { t } from "../_i18n";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "preact/hooks";
import { CF } from "../_common/layout";
import CertificateApplicationNew from "./CertificateApplication/components/CertificateApplicationNew";
import CertificateApplicationOld from "./CertificateApplication/components/CertificateApplicationOld";
import AcademicProgramSelector from "../expediente/components/academicProgramSelector";
import {
  fetchExpedientAcademicProgram,
  fetchExpedientAcademicProgramsSelector,
} from "../_rx/expediente/actions";

export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const studentId = useSelector((state) => state.auth?.loggedUser?.id);
  const finishedAcademicPrograms = useSelector(
    (state) => state.status?.student_meta?.finished_academic_programs || [],
  );
  const [academicProgramSelector, setAcademicProgramSelector] = useState([]);
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState(null);
  const [academicProgram, setAcademicProgram] = useState(null);
  const [useNewCertificateApplication, setUseNewCertificateApplication] = useState(null);
  const [isLoadingAcademicProgram, setIsLoadingAcademicProgram] = useState(true);

  const handleAcademicProgramChange = (program) => {
    setIsLoadingAcademicProgram(true);
    setSelectedAcademicProgram(program);
  };

  useEffect(() => {
    const loadAcademicPrograms = async () => {
      const programs = await dispatch(fetchExpedientAcademicProgramsSelector(studentId));
      const finishedAcademicProgramIds = new Set(
        finishedAcademicPrograms.map((program) => Number(program.id)),
      );
      const finishedPrograms = (programs || []).filter((program) =>
        finishedAcademicProgramIds.has(Number(program.id)),
      );

      setIsLoadingAcademicProgram(Boolean(finishedPrograms.length));
      setAcademicProgramSelector(finishedPrograms);
      setSelectedAcademicProgram(finishedPrograms[0] || null);
    };

    if (studentId && finishedAcademicPrograms.length) loadAcademicPrograms();
  }, [studentId, finishedAcademicPrograms]);

  useEffect(() => {
    const loadAcademicProgram = async () => {
      setIsLoadingAcademicProgram(true);
      setAcademicProgram(null);
      try {
        const detail = await dispatch(
          fetchExpedientAcademicProgram(studentId, selectedAcademicProgram.id),
        );

        setAcademicProgram(detail);
        setUseNewCertificateApplication(detail?.is_new_cat_process === true);
      } finally {
        setIsLoadingAcademicProgram(false);
      }
    };

    if (studentId && selectedAcademicProgram) loadAcademicProgram();
  }, [studentId, selectedAcademicProgram]);

  return (
    <AppPage
      name="certificate-application"
      title={t("certificate_application_title")}
      back={history.goBack}
      class="max-width-980"
    >
      {academicProgramSelector.length > 1 && (
        <CF className="max-width-980 m-x2-top">
          <AcademicProgramSelector
            academicProgramSelector={academicProgramSelector}
            onChange={handleAcademicProgramChange}
            selected={selectedAcademicProgram}
            disabled={isLoadingAcademicProgram}
          />
        </CF>
      )}
      {useNewCertificateApplication === null || !academicProgram ? (
        <p className="t-center m-x2-top">
          <em className="disabled-aspect-gray">{t("Cargando")}. . .</em>
        </p>
      ) : useNewCertificateApplication ? (
        <CertificateApplicationNew
          academicProgram={academicProgram}
          selectedAcademicProgramId={selectedAcademicProgram?.id}
        />
      ) : (
        <CertificateApplicationOld
          academicProgram={academicProgram}
          selectedAcademicProgramId={selectedAcademicProgram?.id}
        />
      )}
    </AppPage>
  );
};
